exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-ffcae3cc] {\r\n  width: 100%;\r\n  table-layout: fixed;\n}\ntable tr[data-v-ffcae3cc] {\r\n  border-top: 1px solid lightgrey;\n}\ntable td[data-v-ffcae3cc] {\r\n  padding: 5px;\n}\ntable td[data-v-ffcae3cc]:nth-child(2) {\r\n  width: 105px;\n}\ntable td[data-v-ffcae3cc]:nth-child(3) {\r\n  width: 70px;\n}\r\n", ""]);

// exports
